export const TERMS_OF_USE_LINK = 'https://www.onerealmortgage.com/terms-of-use';

export const PRIVACY_POLICY_LINK =
  'https://www.onerealmortgage.com/privacy-policy';

export const TC_ONEREAL_PRIVACY_POLICY_LINK =
  'https://www.onereal.com/pages/privacy-policy';

export const TC_ONEREAL_TERMS_OF_USE_LINK =
  'https://www.onereal.com/pages/terms-of-use';

export const TC_ONEREAL_ELECTRONIC_DISCLOSURE_LINK =
  'https://onereal.com/pages/electronic-disclosure';

export const TC_ONEREAL_DATA_POLICY_LINK =
  'https://onereal.com/pages/data-policy';

export const REAL_SUPPORT_LINK = 'support@therealbrokerage.com';

export const PHONE_NUMBER = '17047559034';

export const ELECTRONIC_DISCLOSURE_CONSENT_LINK =
  'https://www.onerealmortgage.com/edisclosure-consent';

export const SECTION_ALIAS = {
  COUNTRY: 'q:country',
  LICENSE: 'q:licensed_in_states',
  REVIEW_APPLICATION: 'q:review_application',
  REAL_ESTATE_LICENSE: 'q:statespecific_licensefile',
  APPLICATION_FEE: 'q:application_fee_payment',
  TEAM_COMPENSATION_PLAN: 'q:team_compensation_plan',
  TEAM_AGREEMENT_ADDENDUM_SIGNATURE: 'q:team_agreement_addendum_signature',
};

export const SECTION_FIELD_ALIAS = {
  COUNTRY_FIELD: 'Country',
  REVIEW_FIELD: 'ReviewApplication',
};
